export default [
	'NOTE',
	'PHONE',
	'MAIL',
	'EMAIL',
	'SMS',
	'PEPPOL',
	'INVOICE_DISPUTE',
	'NONE'
];
